import { Injectable } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';

import { ConfirmDialogComponent } from '../components/confirm-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  constructor(private dialog: MatDialog) {}

  open(options) {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      width: options.width || '450px',
      disableClose: options.disableClose || false,
      data: {
        title: options.title || '',
        message: options.message || '',
        confirmText: options.confirmText || 'CONFIRM',
        cancelText: options.cancelText || 'CANCEL',
        reason: options.reason || '',
        requireConfirmation: options.requireConfirmation || false,
      },
    });

    ref.afterClosed().subscribe((result) => {
      if (result) {
        options.confirmCallback(result);
      }
    });
  }
}

// import { TranslateService } from '@ngx-translate/core';
// , private translateService: TranslateService

// data = {};

// this.translateService.get(['']).subscribe(() => {
//   this.data = {
//     title: this.translateService.instant(options.title),
//     message: options.message ? this.translateService.instant(options.message) : 'Are you sure?',
//     confirmText: options.confirmText
//       ? this.translateService.instant(options.confirmText)
//       : 'Confirm',
//     cancelText: options.cancelText
//       ? this.translateService.instant(options.cancelText)
//       : 'Cancel',
//     reason: options.reason ? this.translateService.instant(options.reason) : false,
//   };
// });
